// Port do Modal Airbnb-style de leyro.es. Mantén o mesmo markup +
// clases para que o look-and-feel sexa idéntico.

import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  wide?: boolean;
  fullscreen?: boolean;
}

export default function Modal({
  open,
  onClose,
  title,
  children,
  wide = false,
  fullscreen = false,
}: ModalProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[100]">
      <DialogBackdrop className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
      <div className={`fixed inset-0 flex ${fullscreen ? '' : 'items-center justify-center p-4'}`}>
        <DialogPanel
          className={[
            'bg-white rounded-2xl shadow-card-hover flex flex-col',
            fullscreen
              ? 'w-full h-full rounded-none'
              : wide
                ? 'w-full max-w-2xl max-h-[90vh]'
                : 'w-full max-w-lg max-h-[90vh]',
          ].join(' ')}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b border-border shrink-0">
            <button
              onClick={onClose}
              aria-label="Pechar"
              className="p-2 rounded-full hover:bg-subtle transition-colors -ml-2"
            >
              <X size={18} className="text-dark" />
            </button>
            {title && <h2 className="font-semibold text-dark text-base">{title}</h2>}
            <div className="w-8" />
          </div>
          <div className="overflow-y-auto flex-1">{children}</div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
